export const bigRouter = {
    path: '/',
    name: 'big',
    redirect:'/home',
    meta: [],
    component: () => {
        return import('@/views/bigScreen/index.vue')
    },
    children:[
      {
          path: 'home',
          name: 'home',
          des: '首页',
          meta: ['首页'],
          component: () => import('@/components/home/index.vue')
      },
      {
          path: 'product',
          name: 'product',
          des: '生产',
          meta: ['生产'],
          component: () => import('@/components/product/index.vue')
      },
      {
          path: 'quality',
          name: 'quality',
          des: '质量',
          meta: ['质量'],
          component: () => import('@/components/quality/index.vue')
      },
      {
          path: 'phm',
          name: 'phm',
          des: '设备诊断',
          meta: ['设备诊断'],
          component: () => import('@/views/ivy/phm/phm.vue')
      },
      {
        path: 'equipment',
        name: 'equipment',
          des: '设备',
          meta: ['设备'],
        component: () => {
          return import('@/views/ivy/equipment/etmIvyScreen.vue')
        }
      },
      { path: 'safety',
        name: 'safety',
        des: '环保',
        meta: ['环保'],
        component: () => import('@/views/ivy/safety/safety.vue')
      },
  ]
}
export const videoLeft = {
    path: '/videoLeft',
    name: 'videoLeft',
    meta: [],
    component: () => {
      return import('@/views/bigScreen/videoLeft.vue')
    }
  }
  export const videoMonitoring = {
    path: '/videoMonitoring',
    name: 'videoMonitoring',
    meta: [],
    component: () => {
      return import('@/views/bigScreen/videoMonitoring.vue')
    }
  }
export const routers = [
    bigRouter,
    videoLeft,
    videoMonitoring,
]



// WEBPACK FOOTER //
// ./src/router/route.js